import { mapState } from "vuex";
export default {
  name: "LoadingIndicator",
  computed: mapState("loading", {
    loaders: function loaders(state) {
      return state.loaders;
    }
  })
};